import React, {Fragment} from 'react';
import {translate} from 'react-i18next';
import SupporterApi from "../../../apis/SupporterApi";
import Popover from "react-awesome-popover";
import QRCode from 'qrcode.react';
import * as moment from "moment";
import Select2 from "react-select2-wrapper";

class TicketToasterProvisions extends React.Component {

    state = {
        loading: true,
        editing: false,
        showAddProvisionPopup: false,
        addProvisionKitchen: null
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.setState({loading: true});
        SupporterApi.getTicketToasterProvisionsForSupporterProject(this.props.supporterId)
            .then((response) => {
                if (response.status === 200 && response.data.success === true) {
                    this.setState({
                        ...response.data.data,
                        loading: false
                    });
                }
            });
    };

    handleFormSubmit = (e) => {
        if(e) e.preventDefault();
        this.setState({loading: true});
        SupporterApi.setTicketToasterProvisionsForSupporterProject(this.props.supporterId, this.state.ticketToasterProvisions.map((ttp) => {
            return {
                ticketToasterProvision: ttp.id,
                kitchenGroup: ttp.uuid,
                amount: ttp.amount
            }
        }))
            .then((response) => {
                if (response.status === 200 && response.data.success === true) {
                    this.setState({
                        ...response.data.data,
                        loading: false,
                        editing: false
                    });
                }
            });
    };

    changeKitchenAmount = (uuid, amount) => {
        let ticketToasterProvisions = this.state.ticketToasterProvisions.map((el) => {
            if (el.uuid === uuid) {
                el.amount = amount.length > 0 ? parseInt(amount) : amount;
            }
            return el;
        });
        this.setState({
            ticketToasterProvisions: ticketToasterProvisions
        });
    };

    addNewProvision = (e) => {
        if (!e.target.value) return true;
        let ticketToasterProvisions = this.state.ticketToasterProvisions.find((el) => el.uuid === e.target.value) === undefined ? this.state.ticketToasterProvisions.concat(
            [{
                ...this.state.availableKitchens.find((el) => el.uuid === e.target.value),
                amount: 1
            }]
        ) : this.state.ticketToasterProvisions.map((el) => {
            if(el.uuid === e.target.value) {
                return {
                    ...el,
                    amount: 1
                }
            }
            return el;
        });
        this.setState({
            ticketToasterProvisions: ticketToasterProvisions,
            showAddProvisionPopup: false
        });
    };

    render() {
        const {t} = this.props;
        return (
            <div className="TicketToasterProvisions ibox">
                <div className="ibox-title">
                    <h5>{t('supporterProject.ticketToasterProvisions.title')}</h5>
                    <div className="ibox-tools">
                        {!this.state.editing ? (
                            <Fragment>
                                <a onClick={() => this.setState({editing: true})} className="m-r">
                                    <i className="fa fa-pencil fa-1-5x"/>
                                </a>
                                {!this.state.loading ? (
                                    <Popover targetClass="" contentClass="rap-popover-content" initZindex={10000}>
                                        <a ref="target">
                                            <i className="fa fa-qrcode fa-1-5x"/>
                                        </a>
                                        <div className="p-md">
                                            <QRCode size={256} value={this.state.uuid}/>
                                        </div>
                                    </Popover>
                                ) : null}
                            </Fragment>
                        ) : (
                            <Fragment>
                                <a onClick={() => {
                                    this.loadData();
                                    this.setState({editing: false});
                                }} className="btn btn-default m-r-xs">
                                    <i className="fa fa-undo"/>
                                </a>
                                <button type="submit" className="btn btn-primary m-r-xs"
                                        disabled={this.state.loading} onClick={this.handleFormSubmit}>
                                    {this.state.loading ? (
                                        <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                    ) : null}
                                    <i id="saveSupporterProjectButton" className="fa fa-save"/>
                                </button>
                            </Fragment>
                        )}
                    </div>
                </div>
                <div className="ibox-content">
                    {this.state.loading ? (
                        <div className="text-center">
                            <i className="fa fa-3x fa-spin fa-spinner"/>
                        </div>
                    ) : (
                        !this.state.editing ? (
                            <div>
                                <table className="table table-bordered">
                                    <tbody>
                                    {this.state.ticketToasterProvisions ? this.state.ticketToasterProvisions.filter(ttp => !!ttp).filter((el) => {
                                        return el.amount.toString() === "" || parseInt(el.amount) > 0
                                    }).map((ttp, ttpI) => (
                                        <tr key={ttpI}>
                                            <td>
                                                {ttp.kitchen}
                                            </td>
                                            <td>
                                                {ttp.backstageArea}
                                            </td>
                                            <td>
                                                {moment(ttp.opensAt).format('DD.MM.YY')} - {moment(ttp.closesAt).format('DD.MM.YY')}
                                            </td>
                                            <td>
                                                {ttp.amount} {t('supporterProject.ticketToasterProvisions.meals')}
                                            </td>
                                        </tr>
                                    )) : null}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div>
                                <form className="form-inline-edit" onSubmit={this.handleFormSubmit}>
                                    <table className="table table-bordered">
                                        <tbody>
                                        {this.state.ticketToasterProvisions ? this.state.ticketToasterProvisions.filter(ttp => !!ttp).filter((el) => {
                                            return el.amount.toString() === "" || parseInt(el.amount) > 0
                                        }).map((ttp, ttpI) => (
                                            <tr key={ttpI}>
                                                <td>
                                                    {ttp.kitchen}
                                                </td>
                                                <td>
                                                    {ttp.backstageArea}
                                                </td>
                                                <td>
                                                    {moment(ttp.opensAt).format('DD.MM.YY')} - {moment(ttp.closesAt).format('DD.MM.YY')}
                                                </td>
                                                <td>
                                                    <input type="text" value={ttp.amount} className="form-control"
                                                           onChange={(e) => this.changeKitchenAmount(ttp.uuid, e.target.value)}/>
                                                    {t('supporterProject.ticketToasterProvisions.meals')}
                                                </td>
                                                <td>
                                                    <button type="button" className="btn btn-danger btn-xs"
                                                            onClick={() => this.changeKitchenAmount(ttp.uuid, 0)}>
                                                        <i className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        )) : null}
                                        </tbody>
                                    </table>
                                </form>
                                <Popover targetClass="" onOpen={() => this.setState({showAddProvisionPopup: true})}
                                         onClose={() => this.setState({showAddProvisionPopup: false})}
                                         open={this.state.showAddProvisionPopup} contentClass="rap-popover-content">
                                    <button ref="target"
                                            className="btn btn-xs btn-primary" type="default">
                                        <i className="fa fa-plus"/>
                                    </button>
                                    <div className="p-md">
                                        <div
                                            className="form-group" style={{width: '200px'}}>
                                            <label>
                                                {t('supporterProject.ticketToasterProvisions.newProvision.select.title')}
                                            </label>
                                            <Select2 data={
                                                this.state.availableKitchens.filter((el) => this.state.ticketToasterProvisions.length > 0 ? this.state.ticketToasterProvisions.filter(ttp => !!ttp).find((el2) => {
                                                    return !(el2.uuid === el.uuid && el2.amount > 0)
                                                }) : true).map((el) => {
                                                    return {
                                                        id: el.uuid,
                                                        text: `${el.kitchen} // ${el.backstageArea} // ${moment(el.opensAt).format('DD.MM.YY')} - ${moment(el.closesAt).format('DD.MM.YY')}`
                                                    }
                                                })
                                            } onChange={(e) => { /*return false;*/
                                                this.addNewProvision(e);
                                            }} name="newProvisionKitchen"
                                                     options={{placeholder: t('logbook.status.placeholder')}}
                                                     className="width-100p block"/>
                                        </div>
                                    </div>
                                </Popover>
                            </div>
                        )
                    )}
                </div>
            </div>
        )
    }
}

export default translate()(TicketToasterProvisions);
